import { render, staticRenderFns } from "./MessageSendCount.vue?vue&type=template&id=3b91d5c0&"
import script from "./MessageSendCount.vue?vue&type=script&lang=ts&"
export * from "./MessageSendCount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports